import React from 'react'
import cx from 'classnames'

import { Link } from 'components/shared/Link/Link'
import type { RouterLinkProps } from 'components/shared/Link/Link'

import styles from './AuthLink.module.scss'

type AuthLinkProps = Pick<
  RouterLinkProps,
  'className' | 'label' | 'variant' | 'to' | 'redirect'
>

export const AuthLink = ({
  className,
  label,
  variant,
  to,
  redirect,
}: AuthLinkProps) => (
  <Link
    className={cx(
      styles.link,
      styles.variant,
      variant && styles[variant],
      className,
    )}
    color="primary"
    size="medium"
    {...{ label, variant, to, redirect }}
  />
)
